/* Pattebleue : panier AJAX, animations chat, quiz, galerie produit */
(function () {
  'use strict';
  var PB = window.PB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* décode les entités HTML venant de Liquid (&#39; &nbsp; …) */
  var decEl = document.createElement('textarea');
  var dec = function (s) { if (s == null) return ''; s = String(s); if (s.indexOf('&') < 0) return s; decEl.innerHTML = s; return decEl.value; };

  /* ---------- argent ---------- */
  function money(cents) {
    var fmt = dec(PB.moneyFormat || '{{amount_with_comma_separator}} €');
    var n = (Number(cents) || 0) / 100;
    function grp(num, dec, th, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p[1] ? p[0] + ds + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return grp(n, 2, ',', '.');
        case 'amount_no_decimals': return grp(n, 0, ',', '.');
        case 'amount_with_comma_separator': return grp(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return grp(n, 0, '.', ',');
        case 'amount_with_space_separator': return grp(n, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return grp(n, 2, "'", '.');
        default: return grp(n, 2, '.', ',');
      }
    });
  }

  /* ---------- toast ---------- */
  var tt;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = '<svg viewBox="0 0 24 24" width="18" style="color:var(--nose)"><use href="#paw"/></svg>' + esc(dec(msg));
    t.classList.add('on'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---------- tiroir panier ---------- */
  var drawer, scrim, cartBtn, cartState = null;
  var upsells = [];
  try { upsells = JSON.parse(($('#upsell-data') || {}).textContent || '[]'); } catch (e) { upsells = []; }
  upsells.forEach(function (u) { u.label = dec(u.label); u.title = dec(u.title); });

  function openDrawer(v) {
    if (!drawer) return;
    var b = cartBtn.getBoundingClientRect(), r = drawer.getBoundingClientRect();
    drawer.style.setProperty('--cx', (b.left + b.width / 2 - r.left) + 'px');
    drawer.style.setProperty('--cy', (b.top + b.height / 2 - r.top) + 'px');
    if (v) { cartBtn.classList.remove('grow'); void cartBtn.offsetWidth; cartBtn.classList.add('grow'); }
    drawer.classList.toggle('on', v); scrim.classList.toggle('on', v);
    drawer.setAttribute('aria-hidden', String(!v));
    if (v) { var c = $('#closeCart'); if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 300); }
  }

  function renderCart(cart) {
    cartState = cart;
    var badge = $('#badge');
    if (badge) { badge.textContent = cart.item_count; badge.classList.toggle('on', cart.item_count > 0); }
    var total = $('#total'); if (total) total.textContent = money(cart.total_price);
    var ship = $('#ship');
    if (ship) {
      var left = (PB.freeShipping || 0) - cart.total_price;
      var pct = PB.freeShipping ? Math.min(100, cart.total_price / PB.freeShipping * 100) : 100;
      var txt = left > 0 ? esc(dec(PB.strings.freeLeft)).replace('{{ amount }}', '<b>' + money(left) + '</b>') : '<b>' + esc(dec(PB.strings.freeDone)) + '</b>';
      ship.innerHTML = txt + '<div class="track"><i style="width:' + pct + '%"></i></div>';
    }
    var items = $('#items');
    if (items) {
      if (!cart.items.length) {
        items.innerHTML = '<div class="empty"><svg viewBox="0 0 24 24" style="color:var(--water2)"><use href="#paw"/></svg><p>' + esc(dec(PB.strings.empty)) + '</p></div>';
      } else {
        items.innerHTML = cart.items.map(function (it) {
          var img = it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">' : '';
          var vt = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
          return '<div class="line glass"><a class="mini" href="' + esc(it.url) + '">' + img + '</a>' +
            '<div><b>' + esc(it.product_title) + '</b><small>' + vt + money(it.final_price) + '</small></div>' +
            '<div class="qty"><button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="-1">−</button><span>' + it.quantity + '</span>' +
            '<button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="+1">+</button></div></div>';
        }).join('');
      }
    }
    var up = $('#upsell');
    if (up) {
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var handles = cart.items.map(function (i) { return i.handle; });
      var cand = cart.items.length ? upsells.filter(function (u) {
        if (inCart.indexOf(u.product) >= 0) return false;
        if (u.needs && u.needs.length) return u.needs.some(function (h) { return handles.indexOf(h) >= 0; });
        return true;
      })[0] : null;
      if (cand) {
        up.hidden = false;
        up.innerHTML = '<div class="mini">' + (cand.image ? '<img src="' + esc(cand.image) + '" alt="">' : '') + '</div>' +
          '<div><b>' + esc(cand.label) + '</b><br><small>' + esc(cand.title) + ' · ' + money(cand.price) + '</small></div>' +
          '<button class="btn sm add" type="button" data-variant="' + cand.variant + '">+</button>';
      } else up.hidden = true;
    }
    var co = $('#checkout'); if (co) co.disabled = !cart.items.length;
  }

  function fetchCart() {
    return fetch(PB.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(variant, qty) {
    return fetch(PB.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || PB.strings.error); return j; });
    }).then(fetchCart);
  }

  function changeLine(key, qty) {
    return fetch(PB.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* ---------- animation chat : pattes + touffe ---------- */
  function pawTrail(from, tuftOnly) {
    if (reduce || !cartBtn) return;
    var cb = cartBtn.getBoundingClientRect();
    var a = { x: from.left + from.width / 2, y: from.top + from.height / 2 }, b = { x: cb.left + cb.width / 2, y: cb.top + cb.height / 2 };
    var cols = ['#c9a27a', '#f2e6d8', '#8a6a50'];
    for (var i = 0; i < 10; i++) {
      var t = document.createElement('div'); t.className = 'tuft';
      var ang = Math.random() * Math.PI * 2, dist = 30 + Math.random() * 40;
      t.innerHTML = '<svg viewBox="0 0 14 14"><path d="M7 13 C5 9 2 7 1 2 M7 13 C7 8 7 5 7 1 M7 13 C9 9 12 7 13 2" stroke="' + cols[i % 3] + '" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>';
      t.style.left = (a.x - 7) + 'px'; t.style.top = (a.y - 7) + 'px'; document.body.appendChild(t);
      (function (el, ang, dist) {
        var an = el.animate([{ transform: 'translate(0,0) rotate(0) scale(.6)', opacity: 1 }, { transform: 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist - 20) + 'px) rotate(' + (Math.random() * 240 - 120) + 'deg) scale(1.1)', opacity: 0 }], { duration: 800 + Math.random() * 300, easing: 'cubic-bezier(.2,.8,.3,1)' });
        an.onfinish = function () { el.remove(); };
      })(t, ang, dist);
    }
    if (tuftOnly) return;
    var steps = 7, dx = b.x - a.x, dy = b.y - a.y, len = Math.hypot(dx, dy) || 1, rot = Math.atan2(dy, dx) * 180 / Math.PI + 90;
    var nx = -dy / len, ny = dx / len;
    for (var k = 1; k <= steps; k++) {
      var f = k / (steps + 1), side = k % 2 ? 7 : -7, arc = Math.sin(f * Math.PI) * -40;
      var p = document.createElement('div'); p.className = 'paw';
      p.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22"><use href="#paw"/></svg>';
      p.style.left = (a.x + dx * f + nx * side - 11) + 'px'; p.style.top = (a.y + dy * f + ny * side + arc - 11) + 'px';
      p.style.transform = 'rotate(' + rot + 'deg) scale(0)'; document.body.appendChild(p);
      (function (el, delay) {
        var an = el.animate([{ transform: 'rotate(' + rot + 'deg) scale(0)', opacity: 0 }, { transform: 'rotate(' + rot + 'deg) scale(1)', opacity: .95, offset: .25 }, { transform: 'rotate(' + rot + 'deg) scale(.9)', opacity: 0 }], { duration: 900, delay: delay, easing: 'ease-out', fill: 'both' });
        an.onfinish = function () { el.remove(); };
      })(p, k * 90);
    }
  }

  /* ---------- clics ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('.add[data-variant]');
    if (add) {
      e.preventDefault();
      if (add.disabled || add.getAttribute('aria-busy') === 'true') return;
      var inDrawer = !!add.closest('#drawer');
      var rect = add.getBoundingClientRect();
      add.setAttribute('aria-busy', 'true');
      addToCart(add.dataset.variant, parseInt(add.dataset.n, 10) || 1).then(function () {
        try { pawTrail(rect, inDrawer); } catch (err) { /* animation facultative */ }
        if (cartBtn) { cartBtn.classList.remove('bump'); void cartBtn.offsetWidth; cartBtn.classList.add('bump'); }
        if (!inDrawer) setTimeout(function () { openDrawer(true); }, reduce ? 0 : 700);
      }).catch(function (err) { toast(err.message || PB.strings.error); })
        .then(function () { add.removeAttribute('aria-busy'); });
      return;
    }
    var line = e.target.closest('[data-line]');
    if (line) { changeLine(line.dataset.line, parseInt(line.dataset.q, 10)); return; }
  });

  document.addEventListener('pointermove', function (e) {
    var b = e.target.closest && e.target.closest('.btn'); if (!b) return;
    var r = b.getBoundingClientRect();
    b.style.setProperty('--mx', (e.clientX - r.left) + 'px'); b.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });

  /* ---------- formule du héros ---------- */
  function initHero() {
    var heroAdd = $('#heroAdd'); if (!heroAdd) return;
    $$('.opts input[type=radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        heroAdd.dataset.variant = r.value;
        var pr = $('#heroPrice'); if (pr) pr.textContent = r.dataset.price;
      });
    });
    var st = $('#sticky');
    if (st && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        st.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(heroAdd);
    }
  }

  /* ---------- quiz ---------- */
  var QZ = [
    { q: 'Que mange-t-il surtout ?', o: [['Des croquettes', 2], ['Moitié croquettes, moitié pâtée', 1], ['Surtout de la pâtée', 0]] },
    { q: 'Tu le vois boire…', o: [['Rarement, presque jamais', 2], ['De temps en temps', 1], ['Souvent, plusieurs fois par jour', 0]] },
    { q: 'Où vit-il ?', o: [['En appartement, sans sortir', 2], ['Il sort un peu', 1], ['Il sort beaucoup', 0]] },
    { q: 'Quel âge a-t-il ?', o: [['Plus de 7 ans', 2], ['Entre 1 et 7 ans', 1], ["Moins d'un an", 0]] }
  ];
  function initQuiz() {
    $$('[data-quiz]').forEach(function (root) {
      var qi = 0, qs = 0;
      var start = $('[data-qz-start]', root), step = $('[data-qz-step]', root), res = $('[data-qz-res]', root);
      var anim = function (el) { el.classList.remove('qz-anim'); void el.offsetWidth; el.classList.add('qz-anim'); };
      function show() {
        var s = QZ[qi];
        $('[data-qz-n]', root).textContent = 'Question ' + (qi + 1) + ' sur ' + QZ.length;
        $('[data-qz-q]', root).textContent = s.q;
        $('[data-qz-bar]', root).style.width = (qi / QZ.length * 100) + '%';
        $('[data-qz-opts]', root).innerHTML = s.o.map(function (o) { return '<button class="btn" type="button" data-qv="' + o[1] + '">' + esc(o[0]) + '</button>'; }).join('');
        anim(step);
      }
      function result() {
        $('[data-qz-bar]', root).style.width = '100%'; step.hidden = true; res.hidden = false;
        var high = qs >= 5, mid = qs >= 3;
        $('[data-qz-title]', root).textContent = high ? 'Ton chat a de bonnes chances de ne pas boire assez.' : mid ? 'Ton chat pourrait boire un peu plus.' : 'Ton chat boit sûrement bien.';
        $('[data-qz-tag]', root).className = 'tag' + (high ? '' : ' m');
        var tips = high ? ["Les chats nourris aux croquettes trouvent très peu d'eau dans leur repas.", 'Une eau qui bouge les attire : beaucoup boivent plus souvent avec une fontaine.', "Place l'eau loin de sa gamelle de nourriture et de sa litière."]
          : mid ? ["Multiplie les points d'eau dans la maison.", 'Une eau qui bouge et toujours fraîche donne envie de boire plus souvent.', "Change l'eau tous les jours si elle stagne."]
          : ['Continue comme ça : une eau fraîche et propre reste la base.', "Une fontaine garde l'eau fraîche sans que tu y penses."];
        $('[data-qz-tips]', root).innerHTML = tips.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
        anim(res);
      }
      $('[data-qz-go]', root).addEventListener('click', function () { start.hidden = true; step.hidden = false; qi = 0; qs = 0; show(); });
      $('[data-qz-opts]', root).addEventListener('click', function (e) {
        var b = e.target.closest('[data-qv]'); if (!b) return;
        qs += Number(b.dataset.qv); qi++; qi < QZ.length ? show() : result();
      });
      $('[data-qz-again]', root).addEventListener('click', function () { qi = 0; qs = 0; res.hidden = true; step.hidden = false; show(); });
      if (/customer_posted=true/.test(location.search)) {
        start.hidden = true; res.hidden = false;
        $('[data-qz-title]', root).textContent = 'Merci !';
        root.scrollIntoView({ block: 'center' });
      }
    });
  }

  /* ---------- galerie et quantité de la fiche produit ---------- */
  function initProduct() {
    var galleries = [];
    $$('[data-gallery]').forEach(function (g) {
      var tr = $('[data-track]', g), th = $$('[data-thumbs] button', g);
      if (!tr) return;
      var n = tr.children.length, cur = 0, busy = null;
      var mark = function (i) {
        th.forEach(function (b, j) { b.classList.toggle('on', j === i); });
        var tb = th[i]; if (tb && tb.parentNode.scrollWidth > tb.parentNode.clientWidth) tb.parentNode.scrollTo({ left: tb.offsetLeft - tb.parentNode.clientWidth / 2 + tb.offsetWidth / 2, behavior: 'smooth' });
        $$('video', tr).forEach(function (v) { if (v.closest('.slide') !== tr.children[i]) v.pause(); });
      };
      var goTo = function (i, instant) {
        if (!n) return;
        i = ((i % n) + n) % n;
        var far = Math.abs(i - cur) > 1 || !!busy; // clics rapides : on saute directement
        cur = i; mark(i);
        clearTimeout(busy); busy = setTimeout(function () { busy = null; }, 450);
        if (reduce || instant || far) {
          if (!reduce && !instant) tr.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 260, easing: 'ease-out' });
          tr.scrollTo({ left: i * tr.clientWidth, behavior: 'instant' });
        } else tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
      };
      // glisser au doigt : on suit la position seulement quand aucun clic n'anime la galerie
      var st;
      tr.addEventListener('scroll', function () {
        if (busy) return;
        clearTimeout(st); st = setTimeout(function () { var i = Math.round(tr.scrollLeft / (tr.clientWidth || 1)); if (i !== cur) { cur = i; mark(i); } }, 90);
      }, { passive: true });
      th.forEach(function (b) { b.addEventListener('click', function () { goTo(Number(b.dataset.th)); }); });
      $$('[data-go]', g).forEach(function (b) { b.addEventListener('click', function () { goTo(cur + Number(b.dataset.go)); }); });
      window.addEventListener('resize', function () { tr.scrollTo({ left: cur * tr.clientWidth, behavior: 'instant' }); });
      galleries.push(goTo);
    });
    var showMedia = function (i, instant) { if (i === '' || i == null || isNaN(i)) return; galleries.forEach(function (go) { go(Number(i), instant); }); };
    var addBtn = $('[data-product-add]');
    if (!addBtn) return;
    var qn = 1;
    var updateTotal = function () {
      var tot = $('[data-total]'); if (!tot) return;
      var base = addBtn.dataset.unit ? Number(addBtn.dataset.unit) : null;
      if (base != null) tot.textContent = money(base * qn);
    };
    // prix unitaire en centimes, lu depuis le texte affiché au chargement
    var pv = $('[data-price]');
    var parse = function (txt) { var d = String(txt).replace(/[^\d,.]/g, ''); var m = d.match(/^(.*?)[,.](\d{2})$/); return m ? Number(m[1].replace(/[,.]/g, '')) * 100 + Number(m[2]) : Number(d.replace(/[,.]/g, '')) * 100; };
    if (pv) addBtn.dataset.unit = parse(pv.textContent);
    $$('[data-qn]').forEach(function (b) {
      b.addEventListener('click', function () {
        qn = Math.max(1, Math.min(9, qn + Number(b.dataset.qn)));
        $('[data-qn-val]').textContent = qn; addBtn.dataset.n = qn; updateTotal();
      });
    });
    var chk = $('.variant-picker input:checked');
    if (chk && /[?&]variant=/.test(location.search)) showMedia(chk.dataset.media, true);
    $$('.variant-picker input').forEach(function (r) {
      r.addEventListener('change', function () {
        addBtn.dataset.variant = r.value;
        if (pv) pv.textContent = r.dataset.price;
        addBtn.dataset.unit = parse(r.dataset.price); updateTotal();
        showMedia(r.dataset.media);
        var url = new URL(location.href); url.searchParams.set('variant', r.value); history.replaceState(null, '', url);
      });
    });
  }

  /* ---------- démarrage ---------- */
  function init() {
    drawer = $('#drawer'); scrim = $('#scrim'); cartBtn = $('#cartBtn');
    if (cartBtn && drawer) {
      cartBtn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(true); });
      $('#closeCart').addEventListener('click', function () { openDrawer(false); });
      scrim.addEventListener('click', function () { openDrawer(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrawer(false); });
      fetchCart().catch(function () {});
    }
    initHero(); initQuiz(); initProduct();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* ===== v2 : micro-interactions ===== */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('pointerdown',function(e){var b=e.target.closest('.btn');if(!b||reduce)return;var r=b.getBoundingClientRect(),d=Math.max(r.width,r.height)*2.2,sp=document.createElement('span');sp.className='rip';sp.style.width=sp.style.height=d+'px';sp.style.left=(e.clientX-r.left-d/2)+'px';sp.style.top=(e.clientY-r.top-d/2)+'px';b.appendChild(sp);setTimeout(function(){sp.remove()},700)});
  var mb=document.getElementById('menuBtn'),mn=document.getElementById('mnav');
  if(mb&&mn){
    var set=function(v){mb.classList.toggle('on',v);mn.classList.toggle('on',v);mb.setAttribute('aria-expanded',v);mb.setAttribute('aria-label',v?mb.dataset.close:mb.dataset.open)};
    mb.addEventListener('click',function(){set(!mn.classList.contains('on'))});
    mn.addEventListener('click',function(e){if(e.target.closest('a'))set(false)});
    document.addEventListener('click',function(e){if(mn.classList.contains('on')&&!e.target.closest('#mnav,#menuBtn'))set(false)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')set(false)});
  }
  if(!reduce&&'IntersectionObserver' in window){
    document.documentElement.classList.add('js');
    var els=[].slice.call(document.querySelectorAll('.reveal'));
    els.forEach(function(el){if(el.getBoundingClientRect().top>innerHeight*0.92)el.classList.add('below')});
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.remove('below');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el)});
  }
})();


/* ===== v3 : ouverture d'un produit avec la même bulle que le panier ===== */
(function(){
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL='a.pic,a.stage,a.tlink';
  try{if(sessionStorage.getItem('pbx')){sessionStorage.removeItem('pbx');document.documentElement.classList.add('pbx-in')}}catch(e){}
  setTimeout(function(){document.documentElement.classList.remove('pbx-in')},1200);
  if(reduce)return;
  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target.closest(SEL);
    if(!a||a.target==='_blank')return;
    var u;try{u=new URL(a.href)}catch(x){return}
    if(u.origin!==location.origin||u.pathname===location.pathname)return;
    e.preventDefault();
    var x=e.clientX,y=e.clientY;
    if(!e.detail){var r=a.getBoundingClientRect();x=r.left+r.width/2;y=r.top+r.height/2}
    var o=document.createElement('div');o.className='pgx';o.setAttribute('aria-hidden','true');
    o.style.setProperty('--cx',x+'px');o.style.setProperty('--cy',y+'px');
    document.body.appendChild(o);void o.offsetWidth;o.classList.add('on');
    try{sessionStorage.setItem('pbx','1')}catch(err){}
    setTimeout(function(){location.href=a.href},450);
  });
  window.addEventListener('pageshow',function(e){if(e.persisted)document.querySelectorAll('.pgx').forEach(function(o){o.remove()})});
  /* précharge la fiche dès le survol pour que l'ouverture soit rapide */
  var done={};
  function pf(e){var a=e.target.closest&&e.target.closest(SEL);if(!a||done[a.href])return;done[a.href]=1;var l=document.createElement('link');l.rel='prefetch';l.href=a.href;document.head.appendChild(l)}
  document.addEventListener('pointerover',pf,{passive:true});
  document.addEventListener('touchstart',pf,{passive:true});
})();

/* ===== bannière cookies PatteBleue : textes au tutoiement, sans mention du prestataire ===== */
(function(){
  function setT(el,txt){if(!el)return;var n=[].slice.call(el.childNodes).filter(function(x){return x.nodeType===3&&x.textContent.trim()})[0];if(n){n.textContent=txt}else if(!el.children.length){el.textContent=txt}else{el.insertBefore(document.createTextNode(txt),el.firstChild)}}
  function q(s){return document.querySelector(s)}
  function banner(){
    var b=q('#shopify-pc__banner');if(!b||b.dataset.pb)return;b.dataset.pb='1';
    setT(q('#shopify-pc__banner__body-title'),'Un petit cookie ?');
    var p=b.querySelector('.shopify-pc__banner__body p');
    if(p){p.textContent='On utilise des cookies pour faire marcher la boutique, mesurer les visites et adapter nos pubs. Rien sans ton accord. ';var a=document.createElement('a');a.href='/pages/cookies';a.textContent='En savoir plus';a.id='shopify-pc__banner__body-policy-link';p.appendChild(a)}
    var s=q('#shopify-pc__banner__btn-manage-prefs span');setT(s,'Choisir');
    setT(q('#shopify-pc__banner__btn-accept'),'Ça me va');
    setT(q('#shopify-pc__banner__btn-decline'),'Non merci');
  }
  function prefs(){
    var d=q('#shopify-pc__prefs__dialog');if(!d||d.dataset.pb)return;d.dataset.pb='1';
    setT(q('#shopify-pc__prefs__header-title'),'Tes cookies');
    setT(q('#shopify-pc__prefs__header-accept'),'Tout accepter');
    setT(q('#shopify-pc__prefs__header-decline'),'Tout refuser');
    setT(q('#shopify-pc__prefs__header-save'),'Enregistrer mes choix');
    setT(d.querySelector('.shopify-pc__prefs__intro h3'),'C’est toi qui choisis');
    setT(d.querySelector('.shopify-pc__prefs__intro p'),'Voici les cookies qu’on utilise. Coche ceux que tu acceptes, tu peux changer d’avis quand tu veux en bas de page.');
    var c={essential:['Nécessaires','Indispensables pour faire marcher la boutique : panier, paiement, sécurité. Toujours actifs.'],preferences:['Personnalisation','Retiennent tes choix pour que ta prochaine visite soit plus simple.'],marketing:['Publicité','Nous permettent de te montrer des pubs PatteBleue ailleurs, par exemple sur Instagram ou TikTok.'],analytics:['Mesure des visites','Nous aident à voir quelles pages plaisent, pour améliorer la boutique.']};
    Object.keys(c).forEach(function(k){var o=q('#shopify-pc__prefs__'+k);if(!o)return;setT(o.querySelector('label'),c[k][0]);setT(o.querySelector('p'),c[k][1])});
    var x=q('#shopify-pc__prefs__header-close');if(x)x.setAttribute('aria-label','Fermer');
  }
  function run(){banner();prefs()}
  run();
  new MutationObserver(run).observe(document.body,{childList:true,subtree:true});
})();
